import React from "react";
import "./NewSettings.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Menu, MenuItem } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
// import OrganisationDetails from "./OrganisationSettings/OrganisationDetails/OrganisationDetails";

function EmployerSettings() {
  const navigate = useNavigate();

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  return (
    <Box className="newSettingWrapper">
      <Grid container>
        <Grid xs={12} spacing={3}>
          <h3 className="pageTitle mb-0 ">
            <Link
              onClick={() => {
                navigate("/Homeemployer");
              }}
            >
              <ChevronLeftIcon />
            </Link>
            Settings
          </h3>
        </Grid>

        <Grid
          xs={12}
          sx={{ maxWidth: "1600px", margin: "auto" }}
          className="innerSection"
        >
          <Grid container spacing={3}>
            <Grid lg={3} xs={6}>
              <div className="MenuBox">
                <h4>General</h4>
                <div className="menulistBox">
                  <span className="general"></span>
                  <ul className="menulist">
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {
                          console.log("Tap");
                          navigate(
                            "/SettingModuleFormm?page=personalSetting&section=general"
                          );
                        }}
                      >
                        Personal Settings
                      </Link>
                    </li>
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {
                          navigate("/SettingModuleForm");
                        }}
                      >
                        Email Settings
                      </Link>
                    </li>
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {
                          navigate(
                            "/SettingModuleForm?page=appearance&section=general"
                          );
                        }}
                      >
                        Appearance
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            <Grid lg={3} xs={6}>
              <div className="MenuBox">
                <h4>Organisation</h4>
                <div className="menulistBox">
                  <span className="organisation"></span>
                  <ul className="menulist">
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {
                          navigate(
                            "/SettingModuleForm?page=CompanyDetails&section=org"
                          );
                        }}
                      >
                        Company Details
                      </Link>
                    </li>
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Branches
                      </Link>
                    </li>
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Departments
                      </Link>
                    </li>
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {
                          navigate(
                            "/SettingModuleForm?page=Taxation&section=org"
                          );
                        }}
                      >
                        Taxation
                      </Link>
                    </li>
                    <li>
                      <Link
                        underline="none"
                        className="listItem "
                        onClick={() => {
                          navigate(
                            "/SettingModuleForm?page=Currencies&section=org"
                          );
                        }}
                      >
                        Currencies
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            <Grid lg={3} xs={6}>
              <div className="MenuBox">
                <h4>User And Controls</h4>
                <div className="menulistBox">
                  <span className="userControl"></span>
                  <ul className="menulist">
                    <li>
                      <Link
                        underline="none"
                        className="listItem users"
                        onClick={() => {}}
                      >
                        Users
                      </Link>
                    </li>
                    <li>
                      <Link
                        underline="none"
                        className="listItem access_control"
                        onClick={() => {}}
                      >
                        Access Control
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            {/* <Grid lg={3} xs={6}>
              <div className="MenuBox">
                <div className="menuBoxHeading">
                  <h4>Customisation</h4>
                </div>
                <div className="menulistBox">
                  <span className="customisation"></span>
                  <ul className="menulist">
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem module active"
                        onClick={() => {
                          navigate(
                            "/SettingModuleForm?page=Modules&section=custom"
                          );
                        }}
                      >
                        Modules
                      </Link>
                    </li>
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem templates"
                        onClick={() => {
                          navigate(
                            "/SettingModuleForm?page=Modules&section=templates"
                          );
                        }}
                      >
                        Templates
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            <Grid lg={3} xs={6}>
              <div className="MenuBox">
                <div className="menuBoxHeading">
                  <h4>Portal Setup</h4>
                </div>
                <div className="menulistBox">
                  <span className="portalSetup"></span>
                  <ul className="menulist">
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Employee Portal
                      </Link>
                    </li>
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Employer Portal
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            <Grid lg={3} xs={6}>
              <div className="MenuBox">
                <h4>Data Admin</h4>
                <div className="menulistBox">
                  <span className="dataAdmin"></span>
                  <ul className="menulist">
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Storage
                      </Link>
                    </li>
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Export
                      </Link>
                    </li>
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Activity Log
                      </Link>
                    </li>
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem "
                        onClick={() => {}}
                      >
                        Audit Log
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            <Grid lg={3} xs={6}>
              <div className="MenuBox">
                <div className="menuBoxHeading">
                  <h4>Developer Space</h4>
                </div>
                <div className="menulistBox">
                  <span className="developerSpace"></span>
                  <ul className="menulist">
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem integartions"
                        onClick={() => {}}
                      >
                        Integrations
                      </Link>
                    </li>
                    <li>
                      <Link
                        
                        underline="none"
                        className="listItem webhook"
                        onClick={() => {}}
                      >
                        API & Webhooks
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default EmployerSettings;
